import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppReadyService {
  private readonly readySig = signal(false);
  readonly isReady = this.readySig.asReadonly();

  setReady(): void {
    this.readySig.set(true);
  }
}

